import * as R from 'ramda';
import PropTypes from 'prop-types';

const {enums} = window.sn;
const {ContentType, ContentApprovalStatus} = enums;

const ContentMetadataPropType = PropTypes.shape({
    admin_distribution_approval_status: PropTypes.oneOf(R.values(ContentApprovalStatus)),
    brand_distribution_approval_status: PropTypes.oneOf(R.values(ContentApprovalStatus)),
    notified_to_post_at: PropTypes.string,
    caption: PropTypes.string,
    content_extension: PropTypes.string.isRequired,
    content_metadata_id: PropTypes.number.isRequired,
    content_thumbnail_extension: PropTypes.string.isRequired,
    content_type: PropTypes.oneOf(R.values(ContentType)),
    content_url: PropTypes.string.isRequired,
    has_distribution_on_campaign: PropTypes.oneOf([0, 1]).isRequired,
    invite_id: PropTypes.string.isRequired,
    lead_id: PropTypes.number.isRequired,
    media_id: PropTypes.string.isRequired,
    post_id: PropTypes.number.isRequired,
    thumbnail_url: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired
});

export default ContentMetadataPropType;



// WEBPACK FOOTER //
// ./approval_queues/proptypes/index.js